import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type {
  IDocumentReaderUploadBatchCreatedResponse,
  IDocumentReaderUploadFileInput,
} from './types';

export async function appendDocumentReaderUploadFiles(
  uploadId: string,
  files: readonly IDocumentReaderUploadFileInput[],
  signal?: AbortSignal
): Promise<
  CommendaAiMutationResult<IDocumentReaderUploadBatchCreatedResponse>
> {
  return AgentApiRequestHelper.mutate<IDocumentReaderUploadBatchCreatedResponse>(
    `agent-platform/document-reader/uploads/${encodeURIComponent(uploadId)}/files`,
    { method: 'POST', body: { files }, ...(signal ? { signal } : {}) },
    'Could not add these files to the data room.'
  );
}
